import { useScopedAppFlagStore } from '@frontend/scope';

interface UseFormsSubmissionV2Results {
  canUseFormsSubmissionV2: boolean;
}

export const useFormsSubmissionV2FeatureFlag = (): UseFormsSubmissionV2Results => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();

  return {
    canUseFormsSubmissionV2: getFeatureFlagValue('forms:enable-submission-v2'),
  };
};
